// Kleiner Aktionsknopf im Formular (Prototyp `isAddBtn`): Gold-Pille, grau oder rot.
import type { Icon } from '@phosphor-icons/react';
import { KNOPF } from './form-stil';

export function FormKleinKnopf({ label, icon: I, onClick, tip, art = 'gold', gesperrt }: {
  label: string;
  icon?: Icon;
  onClick: () => void;
  tip?: string;
  art?: 'gold' | 'grau';
  gesperrt?: boolean;
}) {
  const s = art === 'gold' ? KNOPF.gold : KNOPF.grau;
  return (
    <button type="button" onClick={onClick} disabled={gesperrt} data-tip={tip}
      className="pf-knopf flex shrink-0 items-center self-start border-none"
      style={{
        height: 40, padding: '0 16px', borderRadius: 999, gap: 6, font: 'inherit', fontSize: 13, fontWeight: 800,
        background: s.flaeche, color: s.text, boxShadow: art === 'gold' ? 'inset 0 1px 1px rgba(255,255,255,0.45)' : 'none',
        cursor: gesperrt ? 'not-allowed' : 'pointer', opacity: gesperrt ? 0.4 : 1,
      }}>
      {I && <I aria-hidden size={13} weight="bold" />}
      {label}
    </button>
  );
}

/** Runder Icon-Knopf (z. B. „Zeitfenster löschen“): neutral oder rot. */
export function FormRundKnopf({ label, icon: I, onClick, art = 'neutral' }: {
  label: string;
  icon: Icon;
  onClick: () => void;
  art?: 'neutral' | 'gefahr';
}) {
  return (
    <button type="button" onClick={onClick} aria-label={label} data-tip={label}
      className="pf-knopf flex shrink-0 cursor-pointer items-center justify-center self-center rounded-full border-none"
      style={{
        width: 40, height: 40,
        background: art === 'gefahr' ? 'rgba(255,95,87,0.12)' : 'rgba(255,255,255,0.09)',
        color: art === 'gefahr' ? '#ff7b72' : '#fff', boxShadow: 'inset 0 0.5px 0 rgba(255,255,255,0.14)',
      }}>
      <I size={15} weight="bold" />
    </button>
  );
}
